import api from './api'

export function valueAsNumber (value) {
  if (typeof value === 'undefined') {
    return 0
  }

  if (typeof value === 'number') {
    return value
  }

  return parseFloat(value.replace(',', '.'))
}

export function trans (string, translations) {
  if (typeof translations !== 'object') {
    return string
  }
  if (!translations) {
    return string
  }
  return translations[string] ? translations[string] : string
}

export function keepDimensions (dimensions, data) {
  const levels = Array.from(new Array(dimensions), () => 0)
  let me = data.filter(d => {
    for (let i = 0; i < dimensions; ++i) {
      if (d['Group' + i + 'UniqueName'].substr(-14) === '.UNKNOWNMEMBER') {
        return false
      }
      if (d['Group' + i + 'Level'] > levels[i]) {
        levels[i] = d['Group' + i + 'Level']
      }
    }
    return true
  }).filter(d => {
    for (let i = 0; i < dimensions; ++i) {
      if (d['Group' + i + 'Level'] < levels[i]) {
        return false
      }
    }
    return true
  })
  return me
}

export function buildCropFunction (valueGetter, vm) {
  if (!vm.limit) {
    return d => d
  }

  return data => {
    const unzip = data.map((d, i) => {
      return { index: i, value: valueGetter(d), kept: false }
    })

    unzip.sort((a, b) => {
      if (a.value < b.value) {
        return vm.limit > 0 ? 1 : -1
      }
      if (a.value > b.value) {
        return vm.limit > 0 ? -1 : 1
      }
      return 0
    })

    const kept = {}
    const keptSlice = unzip.slice(0, Math.abs(vm.limit))
    const last = keptSlice[keptSlice.length - 1]

    unzip.forEach((d, i) => {
      kept[d.index] = i < Math.abs(vm.limit) || (!vm.limitStrict && d.value === last.value)
    })

    return data.filter((d, i) => typeof kept[i] !== 'undefined' && kept[i])
  }
}

export function floatVal(d, measure) {
  return valueAsNumber(d[measure])
}

function isMember (leaf, type) {
  let k = leaf.Group0UniqueName.split('.')
  return k[k.length - 1] === type.toUpperCase() + 'MEMBER'
}

function identity (v) { return v }

function normalize (data, {measure, typed = identity, measureKey = 'count', normalizeExtra = identity, fallback}) {
  let norm = {
    id: data.Group0UniqueName,
    key: api.data.key(data),
    level: data.Group0Level,
    name: data.Group0Caption,
    data: data
  }
  if (api.data.parent(data)) {
    norm.parent = api.data.parent(data)
  }
  if (data[measure] !== undefined) {
    norm[measureKey] = typed(data[measure])
  }
  else if (typeof fallback !== 'undefined') {
    norm[measureKey] = fallback
  }
  return normalizeExtra(norm)
}

function index (data, opts) {
  return data.reduce((acc, leaf) => {
    if (isMember(leaf, 'unknown')) {
      return acc
    }
    leaf = normalize(leaf, opts)
    if (opts.extraDimension) {
      if (typeof acc[leaf.id] === 'undefined') {
        leaf.values = []
        acc[leaf.id] = leaf
      }
      if (leaf.data.Group1UniqueName.substr(-14) !== '.UNKNOWNMEMBER') {
        acc[leaf.id].values.push({
          label: leaf.data.Group1Caption,
          key: leaf.data.Group1UniqueName,
          value: leaf[opts.measureKey || 'count']
        })
      }
    }
    else {
      acc[leaf.id] = leaf
    }
    return acc
  }, {})
}

export function asTree (data, opts) {
  let root, all
  let indexed = index(data, opts)
  Object.entries(indexed).forEach(([, leaf]) => {
    if (leaf.parent === undefined) {
      root = leaf
    }
    let i = leaf.parent
    if (i && indexed[i]) {
      indexed[i].count = undefined
      if (indexed[i].children) {
        indexed[i].children.push(leaf)
      } else {
        indexed[i].children = [leaf]
      }
    } else {
      all = i
    }
  }, {})
  return root ? root : {
    id: all,
    key: 'All',
    level: 0,
    name: 'Tous',
    children: Object.keys(indexed).map(k => indexed[k]).filter(i => i.parent === all)
  }
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/dataFilter.js